import $ from 'jquery'

const { __ } = wp.i18n

$(document).ready(function() {

  const brochureModal = $(`.brochure-modal`)

  const brochureBtn = $(`.brochure-btn`)

  let brochureUrl = false
  let brochureTitle = false
  let brochureId = false
  let brochureTermsIds = false

  if (brochureModal.length > 0) {
    const brochureForm = brochureModal.find('.brochure-form')
    const brochureDownloaded = brochureModal.find('.brochure-downloaded')
    brochureForm.parsley().on('form:success', function() {
      brochureForm.attr('data-success', 'true')
    })

    brochureForm.parsley().on('form:error', function() {
      brochureForm.attr('data-success', 'false')
    })

    brochureBtn.each((i, el) => {
      $(el).on('click', (e) => {
        brochureUrl = $(el).data('url')
        brochureTitle = $(el).data('title')
        brochureId = $(el).data('id')
        brochureTermsIds = $(el).data('terms-ids')
        if (sessionStorage.getItem('brochure-email') && sessionStorage.getItem('brochure-phone')) {
          brochureModal.modal('hide')
          brochureForm.find('input#brochure_email').val(sessionStorage.getItem('brochure-email'))
          brochureForm.find('input#brochure_phone').val(sessionStorage.getItem('brochure-phone'))
          brochureForm.submit()
        }
      })
    })

    let rgpdBrochure
    setTimeout(() => {
      brochureModal.find('.axeptio_mount').addClass('g-col-12')
      rgpdBrochure = brochureForm.find('.consent-checkbox-input')
      rgpdBrochure.on('change', (e) => {
        brochureModal.find('.axeptio_mount .error').remove()
      })
    }, 500)

    brochureForm.on('submit', function(e) {
      e.preventDefault()

      const formData = new FormData($(this)[0])
      formData.append('action', 'vn_brochure_form')
      formData.append('brochure_id', brochureId)
      formData.append('brochure_terms_ids', brochureTermsIds)
      if (sessionStorage.getItem('brochure-email') && sessionStorage.getItem('brochure-phone')) {
        formData.append('brochure_email', sessionStorage.getItem('brochure-email'))
        formData.append('brochure_email', sessionStorage.getItem('brochure-phone'))
      }

      if (true || (sessionStorage.getItem('brochure-email') && sessionStorage.getItem('brochure-phone'))) {
        downloadBrochure(brochureUrl, formData, brochureForm, brochureDownloaded)
      } else {
        if (brochureModal.find('.error').length === 0) {
          brochureModal.find('.axeptio_mount').append('<p style="color: red;" class="error">' + __('Please check the checkbox!', 'vn') + '</p>')
        }
      }
    })
  }

  function downloadBrochure(brochureUrl, formData, brochureForm, brochureDownloaded) {
    $.ajax({
      url: vnObject.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: formData,
      processData: false,
      contentType: false,
      success: (res) => {
        if (res.success) {
          sessionStorage.setItem('brochure-email', formData.get('brochure_email'))
          sessionStorage.setItem('brochure-phone', formData.get('brochure_phone'))
          fetch(brochureUrl)
            .then(response => response.blob())
            .then(blob => {
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = brochureTitle + '.pdf'
              document.body.appendChild(link)
              link.click()
              link.remove()
              URL.revokeObjectURL(link.href)
              brochureForm.hide()
              brochureDownloaded.addClass('active')
            })
            .catch(err => console.error('Erreur de téléchargement :', err))
        }
      },
    })
  }
})
